export const NAME = 'name';
export const APPLICATION = 'application';
export const BRIEF_URL = 'attachmentUrl';
export const DESCRIPTION = 'description';
